import { EventCategory } from './event-category.model';

export class EventCategoryAdapter extends EventCategory {
  constructor(data: Partial<EventCategoryAdapter> = {}) {
    super(data);
  }
}
